export const generateId = (): string => 
  Math.random().toString(36).substr(2, 9);

export const generateToken = (): string => 
  Math.random().toString(36).substr(2, 16);

export const generateOTP = (): string => 
  Math.random().toString().substr(2, 6);